export default __webpack_public_path__ + "static/media/mangaAtaulfo.5f7a815f.png";